export const GAINS= "Gains"
export const LOSSESS= "Losses"
export const DEFAULT_SORT_FIELD = "size"
export const DEFAULT_SORT_ORDER = "descend"
export const DESCEND = "descend"
export const NUMERIC_COLUMNS = ["vsWholeOrg","favScore","size"]
export const GAIN_FETCH_KEY = "gain"
export const LOSS_FETCH_KEY = "loss"
export const VALID_COUNT_KEY="size"